/**
 * enum {number}
 */
const Action = Object.freeze({
  NORM_PRIORITY: 10,
  HIGH_PRIORITY: 0,
  LOW_PRIORITY: 20
})

export default Action
